export const ProductionEmployee = (json: IProductionEmployee): IProductionEmployeeModel => {
	const { facility_id, first_name, last_name, production_role, is_active, created_at, updated_at, ...rest } = json

	return {
		facilityID: facility_id,
		firstName: first_name,
		lastName: last_name,
		productionRole: production_role,
		isActive: is_active,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		...rest,
	}
}

export const productionEmployeeToJSON = (obj: IProductionEmployeeJson): IProductionEmployeeJson => {
	const { position, ...rest } = obj

	return {
		...rest,
		position: position ?? null,
	}
}
